/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

'use strict';
import * as angular from 'angular';
import { LoggerServiceFactory } from 'src/app/common/logging/LoggerServiceFactory';

angular.module('ticketspaceApp').factory('firebaseIndex', [
	'$q',
	'fbConnection',
	'$timeout',
	'$firebaseUtils',
	'$firebaseArray',
	'$firebaseObject',
	function ($q, fbConnection, $timeout, $firebaseUtils, $firebaseArray, $firebaseObject) {
		const logger = LoggerServiceFactory.create('firebaseIndex');
		//Array instance section
		function IndexFactory(indexRef, dataRef, indexKey) {
			this._baseDataRef = dataRef;
			this.keyToIndex = indexKey || '$id';
			let thing = $firebaseArray.call(this, indexRef);

			return thing;
		}
		IndexFactory.prototype = {
			$dataRef() {
				return this._baseDataRef;
			},
			$$added(snap, prevChild) {
				return this.getNewData(snap);
			},
			//lifecycle method to override how the child is acquired
			$$getDataRef(idxSnap) {
				if (idxSnap._dataRef) {
					return idxSnap._dataRef;
				}
				return this._baseDataRef.child(idxSnap.key);
			},
			// MOC-2679
			$save(indexOrItem, doUpdate: boolean = false) {
				let self = this;
				let item = self._resolveItem(indexOrItem);
				let key = self.$keyAt(item);
				let def = $q.defer();

				let outerZone = Zone.current;

				if (key !== null) {
					let ref = self.$$getDataRef(item);
					let dataJSON;

					try {
						dataJSON = !doUpdate ? $firebaseUtils.toJSON(item) : $firebaseUtils.toJSON(indexOrItem);
						logger.log('Data json', dataJSON);
					} catch (err) {
						def.reject(err);
						logger.log('Err', err);
					}
					if (typeof dataJSON !== 'undefined') {
						if (doUpdate) {
							fbConnection
								.update(ref, dataJSON)
								.then(
									$firebaseUtils.runInZone(outerZone, function () {
										self.$$notify('child_changed', key);
										def.resolve(ref);
									})
								)
								.catch(function (err) {
									logger.error(err);
									$firebaseUtils.runInZone(outerZone, def.reject);
								});
						} else {
							$firebaseUtils
								.doSet(ref, dataJSON)
								.then(
									$firebaseUtils.runInZone(outerZone, function () {
										self.$$notify('child_changed', key);
										def.resolve(ref);
									})
								)
								.catch(function (err) {
									logger.error(err);
									$firebaseUtils.runInZone(outerZone, def.reject);
								});
						}
					}
				} else {
					def.reject('Invalid record; could not determine key for ' + indexOrItem);
				}

				return def.promise;
			},
			//required keys:
			//$id
			//$indexData - maybe don't use this at all and rely entirely on $id
			$$addedIdx(snap, idxSnap) {
				let thing = snap.val();
				if (!angular.isObject(thing)) {
					thing = { $value: thing };
				}
				thing.$id = idxSnap.key;
				thing.$indexData = idxSnap.val();
				//logger.log('thing', thing);
				return thing;
			},
			$$updated(snap) {
				let self = this;
				//logger.log('!!!', snap.key);
				//the key has been updated, in theory if there's any hit here,
				//it should be destroyed and recreated at the new spot,
				//since a key === value parity is assumed. Making this method effectively pointless
				let oldData = this.$getRecord(snap.key);
				let newData = snap.val();
				//logger.log('old', oldData, 'new', newData);
				if (!angular.equals(oldData, newData)) {
					//off the old data callback
					oldData._cleanUp();
					//call $$removedIdx (also create that method and define it's purpose)
					this.$$removedIdx(snap);
					//create a new on callback to the data and call $$addedIdx
					return this.getNewData(snap).then(function (newObj) {
						//logger.log('oldData', oldData, 'newData', newObj);
						let idx = self.$indexFor(snap.key); //<--- continue here
						//logger.log('idx', idx);
						if (idx !== -1) {
							//logger.log('replacing');
							self.$list[idx] = newObj;
						}
					});
				}
				//so...no-oping it
				return false;
			},
			$$updatedIdx(snap) {
				let rec = this.$getRecord(snap.key);
				let changed = false;
				if (rec) {
					changed = $firebaseUtils.updateRec(rec, snap);
					$firebaseUtils.applyDefaults(rec, this.$$defaults);
				}
				return changed;
			},
			$$removed(snap) {
				//logger.log('$$removed', snap.key, snap.val());
				let abort = this.$$removedIdx(snap);
				if (abort) {
					return !abort;
				}
				let rec = this.$getRecord(snap.key);
				//logger.log('$$removed rec', rec);
				if (rec) {
					rec._cleanUp();
				}
				return $firebaseArray.prototype.$$removed.call(this, snap);
			},
			$$removedIdx(snap) {
				// var rec = this.$getRecord(snap.key);
				// if(rec){rec._cleanUp();}
				// return $firebaseArray.prototype.$$removed.call(this,snap);
			},
			$destroy() {
				if (this.$list) {
					this.$list.forEach(function (l) {
						l._cleanUp();
					});
				}
			},
			getNewData(idxSnap) {
				//todo - implement this function to create a new on listener
				// then get the rest of $$update working
				// then go test it.

				let self = this;
				let child = this.$$getDataRef(idxSnap);
				let hasFirsted = false;
				let defer = $q.defer();

				//logger.log('index, get new data', idxSnap.val(), hasFirsted);

				// //consider ripping this out of here so it's not constantly re-declared
				let theCb = child.on(
					'value',
					function (dataSnap) {
						//logger.log('index, get new data on cb', idxSnap.val(), dataSnap.val(), hasFirsted);

						//$$addedIdx
						if (!hasFirsted) {
							let newObj = this.$$addedIdx(dataSnap, idxSnap) || {};
							//consider moving this to an internal parallel so it's not public
							newObj._cleanUp = function () {
								child.off('value', theCb, self);
							};
							hasFirsted = true;
							newObj._debugIdxData = idxSnap.val();
							newObj._dataRef = child;
							//logger.log('index added', newObj, newObj._debugIdxData);
							defer.resolve(newObj);
						}
						//$$updatedIdx
						else {
							$timeout(function () {
								//in theory if the index record doesn't exist it's already been removed
								// so the update call can be safely suppressed
								if (!self.$getRecord(idxSnap.key)) {
									return;
								}
								let changed = self.$$updatedIdx(dataSnap, idxSnap);
								if (changed) {
									self.$$notify();
								}
							});
						}
					},
					this
				);

				return defer.promise;
			},
		};
		let theFactory = $firebaseArray.$extend(IndexFactory);
		theFactory.$extend = function (ChildClass, methods) {
			if (arguments.length === 1 && angular.isObject(ChildClass)) {
				methods = ChildClass;
				ChildClass = function (ref) {
					if (!(this instanceof ChildClass)) {
						return new ChildClass(ref);
					}
					theFactory.apply(this, arguments);
					return this.$list;
				};
			}
			return $firebaseUtils.inherit(ChildClass, theFactory, methods);
		};

		return theFactory;
	},
]);
